import styled, { css, RuleSet } from 'styled-components';
import {
  FlexBetween,
  FlexColumn,
  FlexibleDiv
} from '../../../../styled/common';
import { Typography } from '../../../ui/Typography';
import { Separator } from '../../../ui/RangeFilter/styled';

export const FiltersSection = styled(FlexColumn)`
  padding: 0 15px;
  margin-bottom: 10px;
  ${({
    theme: {
      colors: { border, background }
    }
  }) => css`
    background-color: ${background.primary};
    border-bottom: 0.5px solid ${border.primary};
    border-top: 0.5px solid ${border.primary};
  `}
`;

export const FilterSectionTitle = styled(Typography)`
  color: ${({ theme }) => theme.colors.text.secondary};
  margin: 15px 0;
`;

export const FiltersOptionsWrapper = styled(FlexibleDiv)<{ styles?: RuleSet }>`
  flex-wrap: wrap;
  gap: 10px;

  ${({ styles }) => styles}
`;

export const FieldsContainer = styled(FlexBetween)`
  width: 100%;
  margin-bottom: 15px;
`;

export const chipsStyles = css`
  height: 44px;
  padding: 0 20px;
  border-radius: 100px;

  &[data-active='true'] {
    border-color: #4264fd !important;
    background-color: #4264fd !important;
    color: #fff !important;
  }
`;

export const RangeFilterWrapper = styled.div`
  width: 100%;
  height: 48px;

  div:not([role='button']):not(${Separator}),
  input {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }

  @media screen and (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    width: 345px;
  }

  @media screen and (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    width: 270px;
  }
`;
